module.exports = __webpack_public_path__ + "static/media/red-card.svg.e22bde41.png";